import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 4a3 3 0 013-3h19.93a4 4 0 012.83 1.17l11.07 11.07A4 4 0 0139 16.07V44a3 3 0 01-3 3H4a3 3 0 01-3-3V4z",
			fill: "#fff",
			stroke: "#0E4EFB",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.02 28.61V32H9.23v-9.24h3.17c.5 0 .95.07 1.36.22.4.14.75.35 1.03.6.3.27.51.58.67.94a3.04 3.04 0 010 2.36c-.16.36-.38.66-.67.92-.28.25-.62.45-1.03.6-.4.14-.86.21-1.36.21h-1.38zm0-1.45h1.38c.25 0 .47-.04.66-.11a1.3 1.3 0 00.74-.76c.06-.18.1-.36.1-.54 0-.22-.04-.42-.1-.6a1.3 1.3 0 00-.74-.82c-.2-.08-.41-.12-.66-.12h-1.38v2.95zM16.89 32v-9.24h2.4c.6 0 1.16.1 1.66.32a3.8 3.8 0 012.1 2.22c.19.51.28 1.08.28 1.7v.77c0 .62-.1 1.19-.29 1.71a3.63 3.63 0 01-2.06 2.2c-.48.22-1.02.32-1.6.32h-2.49zm1.8-7.8v6.37h.68c.34 0 .63-.07.9-.2.26-.12.49-.3.67-.55.19-.24.33-.53.42-.87.1-.35.15-.74.15-1.18v-.78c0-.41-.05-.79-.15-1.13-.09-.34-.23-.64-.42-.88a1.9 1.9 0 00-.7-.57c-.27-.14-.6-.2-.96-.2h-.6zm11.91 3.97h-3.96V32h-1.79v-9.24h6.25v1.45h-4.46v2.52h3.96v1.44z",
			fill: "#0E4EFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.59 13H30a3 3 0 01-3-3V2.41L37.59 13z",
			fill: "#fff",
			stroke: "#0E4EFB",
			strokeWidth: 2
		})
	]
});
export default SvgPdf;
